import { Route, Routes } from "react-router-dom";
import Loader from "./components/layouts/loading/loading";
import React, { Suspense } from "react";
import "./styles/style.css";
import { useSelector } from "react-redux";
import EditeListExpenses from "./pages/Accounting/ListExpenses/EditeListExpenses";

// AddCovenantAccounting
const Login = React.lazy(() => import("./pages/auth/login"));
const Protected = React.lazy(() => import("./pages/auth/Protected"));
// const IssueSetting = React.lazy(() =>
//   import("./pages/IssueSetting/IssueSetting")
// );
const EmployeeDash = React.lazy(() => import("./pages/Employee/EmployeeDash"));
const AddEmployee = React.lazy(() => import("./pages/Employee/AddEmployee"));
const Agencies = React.lazy(() => import("./pages/Clients/Agencies"));
const ClientIssues = React.lazy(() => import("./pages/Clients/ClientIssues"));
const AddCaseInfo = React.lazy(() => import("./pages/Clients/AddCaseInfo"));
const CaseDetailMaster = React.lazy(() =>
  import("./pages/Clients/CaseDetailMaster")
);
const Edit = React.lazy(() => import("./pages/Clients/Edit"));
const AddSessions = React.lazy(() => import("./pages/Clients/AddSessions"));
const TaskList = React.lazy(() => import("./pages/TaskList/TaskList"));
const AddTaskList = React.lazy(() => import("./pages/TaskList/AddTaskList"));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));

const ClientDashboard = React.lazy(() =>
  import("./pages/Clients/ClientDashboard")
);

const EditeEmployess = React.lazy(() =>
  import("./pages/Employee/EditeEmployess")
);
const Settings = React.lazy(() => import("./pages/Setting/Settings"));
const SessionsReport = React.lazy(() => import("./pages/reports/Sessions"));
const TasksReport = React.lazy(() => import("./pages/reports/TasksReport"));
const Issues = React.lazy(() => import("./pages/reports/Issues"));
const Judgment = React.lazy(() => import("./pages/reports/Judgment"));
const UsersReport = React.lazy(() => import("./pages/reports/Users"));
const Implementation = React.lazy(() =>
  import("./pages/reports/Implementation")
);
const Clients = React.lazy(() => import("./pages/reports/Clients"));
const Courts = React.lazy(() => import("./pages/reports/Courts"));
const Formulas = React.lazy(() => import("./pages/FormsAndTemplates/Formulas"));
const Models = React.lazy(() => import("./pages/FormsAndTemplates/Models"));
const Files = React.lazy(() => import("./pages/reports/Files"));
const Statistics = React.lazy(() => import("./pages/Statistics/Statistics"));
const AccountingEmployees = React.lazy(() =>
  import("./pages/Accounting/AccountingEmployees/AccountingEmployees")
);
// const InfoAccountingEmployees = React.lazy(() =>
//   import("./pages/Accounting/AccountingEmployees/InfoAccountingEmployees")
// );
const ListExpenses = React.lazy(() =>
  import("./pages/Accounting/ListExpenses/ListExpenses")
);
const AddListExpenses = React.lazy(() =>
  import("./pages/Accounting/ListExpenses/AddListExpenses")
);
const TransfersBetweenAccounts = React.lazy(() =>
  import("./pages/Accounting/TransfersBetweenAccounts")
);
const ClientAccountingsReports = React.lazy(() =>
  import("./pages/Accounting/Reports/Reports")
);

const ClientAccounting = React.lazy(() =>
  import("./pages/ClientAccounting/ClientAccounting")
);
const ContractClientAccounting = React.lazy(() =>
  import("./pages/ClientAccounting/ContractClientAccounting")
);

const AddClientContact = React.lazy(() =>
  import("./pages/ClientAccounting/AddClientContact")
);
const EditeClientContact = React.lazy(() =>
  import("./pages/ClientAccounting/EditeClientContact")
);
const DataContract = React.lazy(() =>
  import("./pages/ClientAccounting/DataContract")
);
const Receipts = React.lazy(() =>
  import("./pages/ClientAccounting/Bonds/Receipts")
);
const ExchangeBonds = React.lazy(() =>
  import("./pages/ClientAccounting/Bonds/ExchangeBonds")
);
const ComapnyAccounting = React.lazy(() =>
  import("./pages/Accounting/ComapnyAccounting/ComapnyAccounting")
);
const Invoices = React.lazy(() =>
  import("./pages/ClientAccounting/Bonds/Invoices")
);

const OfficeIssues = React.lazy(() =>
  import("./pages/OfficeIssues/OfficeIssues")
);
const InfoFormulas = React.lazy(() =>
  import("./pages/FormsAndTemplates/InfoFormulas")
);

const EmployeeReceipts = React.lazy(() =>
  import("./pages/FormsAndTemplates/InfoFormulas")
);

const EmployeeExchange = React.lazy(() =>
  import("./pages/Accounting/AccountingEmployees/Bonds/EmployeeExchange")
);

const CovenantAccounting = React.lazy(() =>
  import("./pages/Accounting/CovenantAccounting/CovenantAccounting")
);

const AddCovenantAccounting = React.lazy(() =>
  import("./pages/Accounting/CovenantAccounting/AddCovenantAccounting")
);

const EditeCovenantAccounting = React.lazy(() =>
  import("./pages/Accounting/CovenantAccounting/EditeCovenantAccounting")
);

function App() {
  const { isAuthLoading } = useSelector((state) => state.AuthSlice);
  const { isEmployeesLoading } = useSelector((state) => state.EmployeesSlice);
  const { isSharedLoading } = useSelector((state) => state.SharedSlice);
  const { isIssueLoading } = useSelector((state) => state.IssueSlice);
  const { isFormsAndTemplatesLoading } = useSelector(
    (state) => state.FormsAndTemplatesSlice
  );
  const { isStatisticsLoading } = useSelector((state) => state.StatisticsSlice);
  const { isHomeLoading } = useSelector((state) => state.HomeSlice);
  const { isAccountingLoading } = useSelector((state) => state.AccountingSlice);

  return (
    <>
      {isAccountingLoading && <Loader />}

      {isAuthLoading && <Loader />}
      {isEmployeesLoading && <Loader />}
      {isSharedLoading && <Loader />}
      {isIssueLoading && <Loader />}
      {isFormsAndTemplatesLoading && <Loader />}
      {isStatisticsLoading && <Loader />}
      {isHomeLoading && <Loader />}
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route element={<Protected />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/employees" element={<EmployeeDash />} />
            <Route path="/employees/add-employee" element={<AddEmployee />} />
            <Route
              path="/employees/edite-employee/:id"
              element={<EditeEmployess />}
            />
            <Route path="/clients" element={<ClientDashboard />} />

            <Route path="/clients/Agencies/:id" element={<Agencies />} />
            <Route
              path="/clients/ClientIssues/:id"
              element={<ClientIssues />}
            />
            <Route path="/clients/AddCaseInfo/:id" element={<AddCaseInfo />} />
            <Route
              path="/clients/CaseDetailMaster/:usrId/:issuseId"
              element={<CaseDetailMaster />}
            />
            <Route
              path="/clients/AddSessions/:usrId/:issuseId/:id"
              element={<AddSessions />}
            />
            <Route path="/clients/edit/:usrId/:issuseId" element={<Edit />} />

            <Route path="/TaskList" element={<TaskList />} />
            <Route path="/TaskList/AddTaskList/:id" element={<AddTaskList />} />
            <Route path="/Models" element={<Models />} />
            <Route path="/Formulas" element={<Formulas />} />
            <Route
              path="/Formulas/InfoFormulas/:id"
              element={<InfoFormulas />}
            />
            <Route path="/settings" element={<Settings />} />
            {/* <Route path="/issue-setting" element={<IssueSetting />} /> */}

            <Route path="/Report/Sessions" element={<SessionsReport />} />
            <Route path="/Report/Procedures" element={<TasksReport />} />
            <Route path="/Report/Issues" element={<Issues />} />
            <Route path="/Report/Judgment" element={<Judgment />} />
            <Route path="/Report/Users" element={<UsersReport />} />
            <Route path="/Report/Implementation" element={<Implementation />} />
            <Route path="/Report/Clients" element={<Clients />} />
            <Route path="/Report/Courts" element={<Courts />} />
            <Route path="/Report/Files" element={<Files />} />
            <Route path="/Statistics" element={<Statistics />} />
            <Route path="/OfficeIssues" element={<OfficeIssues />} />
            <Route path="/ClientAccounting" element={<ClientAccounting />} />
            <Route
              path="/ContractClientAccounting/:id"
              element={<ContractClientAccounting />}
            />
            <Route
              path="/AddClientContact/:id"
              element={<AddClientContact />}
            />
            <Route
              path="/EditeClientContact/:id/:contractId"
              element={<EditeClientContact />}
            />
            {/* EditeClientContact */}
            <Route
              path="/DataContract/:id/:contractId"
              element={<DataContract />}
            />
            <Route
              path="/ClientAccounting/bonds/Receipts/:id"
              element={<Receipts />}
            />
            <Route
              path="/ClientAccounting/bonds/ExchangeBonds/:id"
              element={<ExchangeBonds />}
            />
            <Route path="/ComapnyAccounting" element={<ComapnyAccounting />} />
            <Route
              path="/ClientAccounting/bonds/Invoices/:id"
              element={<Invoices />}
            />
            <Route
              path="/CovenantAccounting"
              element={<CovenantAccounting />}
            />
            <Route
              path="/AddCovenantAccounting"
              element={<AddCovenantAccounting />}
            />
            <Route
              path="/EditeCovenantAccounting/:id/:price"
              element={<EditeCovenantAccounting />}
            />
            <Route
              path="/AccountingEmployees"
              element={<AccountingEmployees />}
            />

            <Route
              path="/AccountingEmployees/bonds/Receipts/:id"
              element={<EmployeeReceipts />}
            />
            <Route
              path="/AccountingEmployees/bonds/ExchangeBonds/:id"
              element={<EmployeeExchange />}
            />
            {/* <Route
              path="/AccountingEmployees/bonds/Receipts/:id"
              element={<InfoAccountingEmployees />}
            /> */}
            <Route path="/ListExpenses" element={<ListExpenses />} />
            <Route path="/AddListExpenses" element={<AddListExpenses />} />
            <Route
              path="/EditeListExpenses/:id"
              element={<EditeListExpenses />}
            />
            {/* EditeListExpenses */}
            <Route
              path="/TransfersBetweenAccounts"
              element={<TransfersBetweenAccounts />}
            />
            <Route
              path="/ClientAccountings/Reports"
              element={<ClientAccountingsReports />}
            />
            <Route path="*" element={<EmployeeDash />} />
          </Route>
          <Route path="/login" element={<Login />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
